import { toParams } from '../../utils';
import { Trans, useTranslation } from '@rpi/i18n';
import React from 'react';
import { Link } from 'react-router-dom';

interface ExpiredRegistrationStatusProps {
  email: string;
}

export const ExpiredRegistrationStatus: React.FC<
  ExpiredRegistrationStatusProps
> = ({ email }) => {
  const { t, i18n } = useTranslation(undefined, { keyPrefix: 'route.auth' });
  const emailExists = email.length > 0;
  const ResendRegEmail = () => (
    <>
      <Trans
        i18nKey={t('expired_registration_status')}
        components={{
          'resend-verification-link': (
            <Link
              className="underline hover:no-underline text-red-dark"
              to={toParams(
                '/auth/sign-up/confirm/',
                new URLSearchParams({ email }),
              )}
            />
          ),
        }}
      />
    </>
  );
  const UnableToResendEmail = () => (
    <>
      <Trans i18nKey={t('resend_verification_failure')} />
      <br />
      <Trans
        i18nKey={t('support')}
        components={{
          'support-link': (
            <a
              aria-label="support"
              href={`https://support.blurb.com/hc/${i18n.language}`}
              className="underline hover:no-underline"
            />
          ),
        }}
      />
    </>
  );
  return <>{emailExists ? <ResendRegEmail /> : <UnableToResendEmail />}</>;
};
